// apps/web/src/components/shell/folha-atalhos.tsx — Fase 17.8, Plano 15 (D-18; UI-SPEC U-14).
// Folha com os atalhos de teclado que existem no sistema (nenhum atalho inventado). Aberta por "?" fora de campo editável e pelo
// item "Atalhos de teclado" do menu do avatar. No Mac mostra ⌘ no lugar de Ctrl.
import { useState, type ReactElement } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { ehMac } from '../../lib/busca/paleta';
import '../../styles/paleta-comandos.css';

export interface FolhaAtalhosProps {
  readonly aberto: boolean;
  readonly onAbertoChange: (aberto: boolean) => void;
}

interface Atalho {
  readonly id: string;
  readonly descricao: string;
  /** Teclas na ordem; "Ctrl" vira ⌘ no Mac. */
  readonly teclas: readonly string[];
}

/** Só os atalhos que existem: paleta, menu lateral, esta folha, navegação da busca, Esc e o seletor de perfil do painel. */
export const ATALHOS: readonly Atalho[] = [
  { id: 'buscar', descricao: 'Buscar telas, pedidos, ordens, lotes e clientes', teclas: ['Ctrl', 'K'] },
  { id: 'menu', descricao: 'Recolher ou expandir o menu', teclas: ['Ctrl', 'B'] },
  { id: 'atalhos', descricao: 'Abrir esta folha de atalhos', teclas: ['?'] },
  { id: 'navegar', descricao: 'Navegar e abrir na busca', teclas: ['↑', '↓', '↵'] },
  { id: 'fechar', descricao: 'Fechar busca, menu flutuante e janelas', teclas: ['Esc'] },
  { id: 'perfil', descricao: 'Trocar de perfil no painel (com o foco no seletor)', teclas: ['←', '→'] },
];

export function FolhaAtalhos({ aberto, onAbertoChange }: FolhaAtalhosProps): ReactElement {
  const [mac] = useState(() => typeof navigator !== 'undefined' && ehMac(navigator));
  return (
    <Dialog open={aberto} onOpenChange={onAbertoChange}>
      <DialogContent className="folha-atalhos sm:max-w-[480px]" data-testid="folha-atalhos">
        <DialogHeader>
          <DialogTitle className="folha-atalhos__titulo text-sm">Atalhos de teclado</DialogTitle>
          <DialogDescription className="sr-only">Atalhos de teclado disponíveis nas telas de gestão.</DialogDescription>
        </DialogHeader>
        <ul className="folha-atalhos__lista">
          {ATALHOS.map((atalho) => (
            <li key={atalho.id} className="folha-atalhos__linha" data-testid={`atalho-${atalho.id}`}>
              <span>{atalho.descricao}</span>
              <span className="folha-atalhos__teclas">
                {atalho.teclas.map((tecla) => <kbd key={tecla} className="kbd-atalho">{mac && tecla === 'Ctrl' ? '⌘' : tecla}</kbd>)}
              </span>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
